import { useMemo } from 'react';
import { ui } from '@procuros/datachecks';

import { DocumentType } from 'support/types';
import { useGenerateWebEDIColumns } from 'components/DataTable';
import { DisplayModes } from 'components/DataTable/Types';

import { useDocumentLineItemsConfig } from './DocumentLineItems/hooks/useDocumentLineItemsConfig';
import { usePinnedColumns } from './helpers';

export const useGenerateLineItemsColumns = ({
  config,
  mode,
  documentType,
  numberOfPinnedColumns,
}: {
  config: ui.LineItemsSection['fields'];
  mode: DisplayModes;
  documentType: DocumentType;
  numberOfPinnedColumns?: number;
}) => {
  const { config: lineItemsConfig, deleteQuantityField } = useDocumentLineItemsConfig(config, mode, documentType);
  const tableConfig = useMemo(() => getTableConfig(mode, documentType), [mode, documentType]);
  const columns = useGenerateWebEDIColumns({
    config: lineItemsConfig,
    ...tableConfig,
    deleteQuantityField,
    nestedLevelField: 'item.name',
    displayMode: mode,
  });

  const pinnedColumns = usePinnedColumns({
    config: lineItemsConfig,
    numberOfPinnedColumns,
    ...tableConfig,
  });

  return { columns, pinnedColumns };
};

const getTableConfig = (mode: DisplayModes, documentType: DocumentType) => {
  if (mode === DisplayModes.view) {
    return {};
  }
  return {
    selectableRows: true,
    deletableRows: documentType !== DocumentType.creditNote,
  };
};
